export default {"src":"/_next/static/media/illustration-heart-clean.45c6e30c.svg","height":54,"width":54};